export default [
  {
    'id': 'rock',
    'defeat': ['scissors']
  },
  {
    'id': 'paper',
    'defeat': ['rock']
  },
  {
    'id': 'scissors',
    'defeat': ['paper']
  }
]



// WEBPACK FOOTER //
// ./src/scripts/config/a.conf.js